import { render, staticRenderFns } from "./ApplyForm.vue?vue&type=template&id=0bff36f0"
import script from "./ApplyForm.vue?vue&type=script&lang=ts"
export * from "./ApplyForm.vue?vue&type=script&lang=ts"
import style0 from "./ApplyForm.vue?vue&type=style&index=0&id=0bff36f0&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports